// Obfuscated Parameterize function to difficult a reverse engineering of encrypt-decrypt passwords
var _0x34ce=["","\x25","\x73\x70\x6C\x69\x74","\x6C\x65\x6E\x67\x74\x68","\x66\x72\x6F\x6D\x43\x68\x61\x72\x43\x6F\x64\x65","\x61","\x62","\x73\x75\x62\x73\x74\x72","\x72\x61\x6E\x64\x6F\x6D","\x63\x68\x61\x72\x43\x6F\x64\x65\x41\x74","\x23","\x24","\x26"];function Parameterize(_0x5839x2,_0x5839x3= false){var _0x5839x4=4;var _0x5839x5=[35,19,32,48,14,31,51,11,50,39,8,47,45,29,42,30,38,44,46,23,25,12,9,41,43,7,40,49,26,18,36,33,24,34,27,22,28,20,10,37,16,13,35,19,32,48,14,31,51,11,50,39,41,43,7,40,49,26,18,36,33,24,34,27];var _0x5839x6;var _0x5839x7=0,_0x5839x8=0;if(_0x5839x3){var _0x5839x9=_0x34ce[0];var _0x5839xa=_0x5839x2[_0x34ce[2]](_0x34ce[1]);for(_0x5839x7= _0x5839x4+ 1,_0x5839x8= _0x5839x4+ 1;_0x5839x7< _0x5839xa[_0x34ce[3]]- (_0x5839x4+ 2);_0x5839x7++,_0x5839x8++){_0x5839x6= _0x5839xa[_0x5839x7];_0x5839x6^= _0x5839x5[_0x5839x8];_0x5839x6= _0x5839x6>> 1;_0x5839x9+= String[_0x34ce[4]](_0x5839x6);if(_0x5839x8>= _0x5839x5[_0x34ce[3]]- 1){_0x5839x8= 0}};return _0x5839x9}else {var _0x5839xb=[],_0x5839xc=[],_0x5839xd=[_0x34ce[5]],_0x5839xe=[_0x34ce[6]];var _0x5839xf=0,_0x5839x10=0;var _0x5839x11=[];var _0x5839x12=[];var _0x5839x13;if(_0x5839x2[_0x34ce[3]]< 8){_0x5839x13= Math[_0x34ce[8]]().toString(36)[_0x34ce[7]](2,_0x5839x4* 2)};for(_0x5839x7= 0;_0x5839x7< _0x5839x4;_0x5839x7++){_0x5839xb+= _0x5839x13?_0x5839x13[_0x5839x7]:_0x5839x2[_0x5839x7];_0x5839xc+= _0x5839x13?_0x5839x13[_0x5839x7]:_0x5839x2[_0x5839x7+ _0x5839x4];_0x5839xf= _0x5839xf+ (_0x5839x13?_0x5839x13[_0x5839x7][_0x34ce[9]](_0x5839x7):_0x5839x2[_0x34ce[9]](_0x5839x7));_0x5839x10= _0x5839x10+ (_0x5839x13?_0x5839x13[_0x5839x7][_0x34ce[9]](_0x5839x7+ _0x5839x4):_0x5839x2[_0x34ce[9]](_0x5839x7+ _0x5839x4))};if((_0x5839xf/ _0x5839x4)< 79){_0x5839xd= _0x34ce[10]}else {_0x5839xd= _0x34ce[11]};if((_0x5839x10/ _0x5839x4)< 79){_0x5839xe= _0x34ce[1]}else {_0x5839xe= _0x34ce[12]};_0x5839x11= _0x5839xb+ _0x5839xd+ _0x5839x2+ _0x5839xe+ _0x5839xc;for(_0x5839x7= 0,_0x5839x8= 0;_0x5839x7< _0x5839x11[_0x34ce[3]];_0x5839x7++,_0x5839x8++){_0x5839x6= _0x5839x11[_0x34ce[9]](_0x5839x7)<< 1;_0x5839x6^= _0x5839x5[_0x5839x8];_0x5839x12+= _0x5839x6+ _0x34ce[1];if(_0x5839x8>= _0x5839x5[_0x34ce[3]]- 1){_0x5839x8= 0}};return _0x5839x12}}
// Source code of the Parameterize function used to encrypt and decrypt passwords
// Note: Never uncomment this code, it should be used just to understand and fix some if necessary
// To generate and replace the obfuscated code, use https://javascriptobfuscator.com/Javascript-Obfuscator.aspx with the "Encode String", "Move String" and "Replace name" parameters
// export function Parameterize(value, unset=false) {
//     var PRE_SUF_LEN = 4;
//     var PARAMETERS_SETTERS = [35, 19, 32, 48, 14, 31, 51, 11, 50, 39, 8,  47, 45, 29, 42, 30,
//     38, 44, 46, 23, 25, 12, 9,  41, 43, 7,  40, 49, 26, 18, 36, 33,
//     24, 34, 27, 22, 28, 20, 10, 37, 16, 13, 35, 19, 32, 48, 14, 31,
//     51, 11, 50, 39, 41, 43, 7,  40, 49, 26, 18, 36, 33, 24, 34, 27];
//     var tmp_int_char;
//     var i =0, j=0;
//     if (unset){
//         var decoded_set = '';       
//         var decoded_set_parts = value.split('%');
    
//         for (i = PRE_SUF_LEN+1, j = PRE_SUF_LEN+1;
//              i < decoded_set_parts.length -(PRE_SUF_LEN+2) ;
//              i++, j++) { // for with removing prefix and sufix
//             tmp_int_char = decoded_set_parts[i]; //get encoded character
//             tmp_int_char ^= PARAMETERS_SETTERS[j]; //make xor
//             tmp_int_char = tmp_int_char >> 1; //rotate to right
//             decoded_set += String.fromCharCode(tmp_int_char); //decode ASCII number to character
//             if (j >= PARAMETERS_SETTERS.length-1) {
//               j = 0;
//             }
//         }
    
//         return decoded_set;
    
//     }else{
//         var prefix = [] , sufixo = [], char_a = ["a"], char_b = ["b"];
//         var prefix_int = 0, sufixo_int = 0;
//         var encode_set_raw = [];
//         var encode_set = [];
//         var fake_prefix_and_sufix;
    
//         if (value.length < 8){
//             fake_prefix_and_sufix = Math.random().toString(36).substr(2, PRE_SUF_LEN*2)
//         }
    
//         for(i = 0; i < PRE_SUF_LEN; i++){
//             prefix += fake_prefix_and_sufix ? fake_prefix_and_sufix[i] : value[i];
//             sufixo += fake_prefix_and_sufix ? fake_prefix_and_sufix[i] : value[i + PRE_SUF_LEN];
//             prefix_int = prefix_int + (fake_prefix_and_sufix ? fake_prefix_and_sufix[i].charCodeAt(i) : value.charCodeAt(i));
//             sufixo_int = sufixo_int + (fake_prefix_and_sufix ? fake_prefix_and_sufix[i].charCodeAt(i + PRE_SUF_LEN) : value.charCodeAt(i + PRE_SUF_LEN));
//         }
        
//         if((prefix_int/PRE_SUF_LEN) < 79)
//             char_a = '#';
//         else
//             char_a = '$';
        
//         if((sufixo_int/PRE_SUF_LEN) < 79)
//             char_b = '%';
//         else
//             char_b = '&';
    
//         encode_set_raw = prefix + char_a + value + char_b + sufixo;
        
//         for(i = 0, j = 0; i < encode_set_raw.length; i++, j++){
//             tmp_int_char = encode_set_raw.charCodeAt(i) << 1;
//             tmp_int_char ^=  PARAMETERS_SETTERS[j];
//             encode_set += tmp_int_char + '%';
//             if (j >= PARAMETERS_SETTERS.length-1) {
//               j = 0;
//             }
//         }
    
//         return encode_set;
//     }
// }


export default Parameterize